// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"5960ebbe","36":"e95f027c","424":"916fb091","463":"43272e63","634":"3b860999","812":"51fe521a","935":"9bb1a6ab"}[chunkId] + ".chunk.js";
};